module.exports = __webpack_public_path__ + "assets/paging-next.aac4b0fc.svg";